import * as ActionTypes from 'state/types'
import { initNotifications } from './notifications'
import { fetchCounters } from './counters'
import Routes from 'shared/utils/api/routes'

export const setToken = token => ({
  type: ActionTypes.SET_TOKEN,
  payload: {
    token
  }
})

export const fetchProfile = () => ({
  type: ActionTypes.PROFILE_REQUEST,
  payload: {
    url: Routes.PROFILE_ROUTE,
    method: 'get'
  },
  meta: {
    successActions: [
      {
        type: ActionTypes.INBOXES_REQUEST,
        provideResponse: false,
        provideParentPayload: false,
        payload: {
          url: Routes.INBOXES_LIST_ROUTE,
          method: 'get'
        }
      },
      {
        type: ActionTypes.FETCH_SETTINGS_INBOXES_OPTIONS_REQUEST,
        provideResponse: false,
        provideParentPayload: false,
        payload: {
          url: Routes.INBOXES_SETTINGS_OPTIONS_ROUTE,
          method: 'get'
        }
      },
      {
        type: ActionTypes.SOCKET_INFO_REQUEST,
        provideResponse: false,
        provideParentPayload: false,
        payload: {
          url: Routes.SOCKET_INFO_ROUTE,
          method: 'get'
        }
      },
      {
        type: ActionTypes.GENERAL_SOCKET_INFO_REQUEST,
        provideResponse: false,
        provideParentPayload: false,
        payload: {
          url: Routes.GENERAL_SOCKET_INFO_ROUTE,
          method: 'get'
        }
      },
      fetchCounters(),
      initNotifications()
    ]
  }
})

export const setOrganisation = (organisationId) => {
  return {
    type: ActionTypes.SET_ORGANISATION_REQUEST,
    payload: {
      url: Routes.ORGANISATION_INFO_ROUTE,
      method: 'get',
      organisationId
    },
    meta: {
      successActions: [
        fetchProfile()
      ]
    }
  }
}
